import type { SearchFiltersSchema } from "@/lib/api/model";

export const GS_GRADE_LOWEST = 1;
export const GS_GRADE_HIGHEST = 15;
export const MAX_OCCUPATIONAL_SERIES = 10;

export const GS_GRADES: number[] = Array.from(
  { length: GS_GRADE_HIGHEST - GS_GRADE_LOWEST + 1 },
  (_, i) => GS_GRADE_LOWEST + i,
);

export function gsGradeLabel(grade: number): string {
  return `GS-${grade}`;
}

const SERIES_CODE_RE = /^\s*(?:(?:gs|gg|nh)\s*-?\s*)?(\d{3,4})\s*$/i;

/**
 * Typed series entry ("2210", "801", "GS-0801") → 4-digit code with leading
 * zeros, or null. The backend rejects codes that aren't in the OPM catalog.
 */
export function normalizeSeriesFreeText(text: string): string | null {
  const m = SERIES_CODE_RE.exec(text);
  return m ? m[1].padStart(4, "0") : null;
}

export function seriesCode(text: string | null | undefined): string | null {
  const m = /^\s*(\d{4})\b/.exec(text ?? "");
  return m ? m[1] : null;
}

export function countFederalFilters(f: SearchFiltersSchema): number {
  return (
    (f.occupational_series?.length ?? 0) +
    (f.gs_grade_min != null ? 1 : 0) +
    (f.gs_grade_max != null ? 1 : 0) +
    (f.gs_include_equivalents ? 1 : 0)
  );
}
